import Swal from "sweetalert2";

export function confirmPublishPopup() {
  return base({
    title: `정말 발행하시겠습니까? <br> 발행 후 수정이 불가합니다.`,
    confirmButtonText: "네",
    cancelButtonText: "아니오",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }
    return false;
  });
}

export function confirmClosePopup() {
  return base({
    title: `정말 나가시겠습니까? <br> 변경사항은 저장되지 않습니다.`,
    confirmButtonText: "네",
    cancelButtonText: "아니오",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }
    return false;
  });
}

export function confirmSavePopup() {
  return base({
    title: `저장 하시겠습니까?`,
    description: `저장하신 후 수정이 불가할 수 있습니다.`,
    confirmButtonText: "네",
    cancelButtonText: "아니오",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }
    return false;
  });
}

function base(descriptions) {
  return Swal.fire({
    title: descriptions.title,
    html: descriptions.html,
    confirmButtonText: descriptions.confirmButtonText,
    cancelButtonText: descriptions.cancelButtonText,
    icon: descriptions.icon,
    showCancelButton: true,
    confirmButtonColor: "orange",
    buttonsStyling: true,
    preConfirm: descriptions.preConfirm,
  });
}

export function success() {
  return Swal.fire({
    title: "완료하였습니다",
    icon: "success",
    iconColor: "orange",
    confirmButtonColor: "orange",
    buttonsStyling: true,
  });
}
